import { CookieCategory, ICookieCategoryInfo } from '../interfaces/cookie-consent.interface';

/**
 * LocalStorage key for cookie consent preferences
 */
export const COOKIE_CONSENT_KEY = 'waytr_cookie_consent';

/**
 * Current version of cookie consent policy
 * Update this when cookie policy changes to re-prompt users
 */
export const COOKIE_CONSENT_VERSION = '1.0.0';

/**
 * Cookie consent will expire after 365 days (GDPR recommendation)
 */
export const COOKIE_CONSENT_EXPIRY_DAYS = 365;

/**
 * Information about each cookie category
 */
export const COOKIE_CATEGORIES: ICookieCategoryInfo[] = [
  {
    key: CookieCategory.NECESSARY,
    titleKey: 'cookie-category-necessary-title',
    descriptionKey: 'cookie-category-necessary-description',
    required: true,
    services: [
      'cookie-service-authentication',
      'cookie-service-session-management',
      'cookie-service-localstorage-encryption',
      'cookie-service-language-preferences',
      'cookie-service-ui-customization',
      'cookie-service-remember-me',
      'cookie-service-indexeddb',
      'cookie-service-socketio',
      'cookie-service-google-fonts',
      'cookie-service-ipwho-geolocation',
    ],
  },
  {
    key: CookieCategory.ANALYTICS,
    titleKey: 'cookie-category-analytics-title',
    descriptionKey: 'cookie-category-analytics-description',
    required: false,
    services: ['cookie-service-sentry-error-tracking', 'cookie-service-sentry-performance', 'cookie-service-sentry-session-replay'],
  },
];
